import { useEffect, useState } from 'react';
import { detectDevice, APP_CONFIG } from '../config/appConfig';

function HomePage() {
  const [showFallback, setShowFallback] = useState(false);
  const [device, setDevice] = useState(null);

  useEffect(() => {
    const detectedDevice = detectDevice();
    setDevice(detectedDevice);

    // Якщо це мобільний пристрій (iOS чи Android), спробуємо редірект
    if (detectedDevice.isMobile) {
      // Додаємо невелику затримку для правильної роботи universal links
      const timeout = setTimeout(() => {
        if (detectedDevice.isIOS) {
          // Для iOS редіректимо прямо на App Store
          window.location.href = APP_CONFIG.ios.appStoreUrl;
        } else if (detectedDevice.isAndroid) {
          // Для Android редіректимо на Google Play
          window.location.href = APP_CONFIG.android.playStoreUrl;
        }
      }, 100);

      // Якщо через 3 секунди редірект не спрацював, показуємо fallback
      const fallbackTimeout = setTimeout(() => {
        setShowFallback(true);
      }, 3000);

      return () => {
        clearTimeout(timeout);
        clearTimeout(fallbackTimeout);
      };
    } else {
      // Для десктопу одразу показуємо fallback
      setShowFallback(true);
    }
  }, []);

  // Функція для генерації QR коду через API
  const generateQRCode = (url) => {
    return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(url)}`;
  };

  if (showFallback) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '600px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            fontSize: '64px',
            marginBottom: '20px'
          }}>
            📱
          </div>
          <h1 style={{
            fontSize: '32px',
            color: '#333',
            marginBottom: '16px',
            fontWeight: '600'
          }}>
            Offer App
          </h1>
          <p style={{
            color: '#666',
            fontSize: '18px',
            marginBottom: '40px',
            lineHeight: '1.5'
          }}>
            Завантажте наш додаток для кращого досвіду користування
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: device?.isDesktop ? '1fr 1fr' : '1fr',
            gap: '30px',
            marginTop: '30px'
          }}>
            {/* iOS Section */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <h3 style={{
                fontSize: '20px',
                color: '#333',
                marginBottom: '15px',
                fontWeight: '500'
              }}>
                📱 iOS
              </h3>
              <img
                src={generateQRCode(APP_CONFIG.ios.appStoreUrl)}
                alt="iOS QR Code"
                style={{
                  marginBottom: '15px',
                  borderRadius: '8px',
                  border: '1px solid #eee'
                }}
              />
              <a
                href={APP_CONFIG.ios.appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#007AFF',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '16px',
                  fontWeight: '500',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#0056CC'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#007AFF'}
              >
                Завантажити з App Store
              </a>
            </div>

            {/* Android Section */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <h3 style={{
                fontSize: '20px',
                color: '#333',
                marginBottom: '15px',
                fontWeight: '500'
              }}>
                🤖 Android
              </h3>
              <img
                src={generateQRCode(APP_CONFIG.android.playStoreUrl)}
                alt="Android QR Code"
                style={{
                  marginBottom: '15px',
                  borderRadius: '8px',
                  border: '1px solid #eee'
                }}
              />
              <a
                href={APP_CONFIG.android.playStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#34A853',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '16px',
                  fontWeight: '500',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#2A8A42'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#34A853'}
              >
                Завантажити з Google Play
              </a>
            </div>
          </div>

          <p style={{
            color: '#999',
            fontSize: '14px',
            marginTop: '30px'
          }}>
            Відскануйте QR-код або натисніть на кнопку для завантаження
          </p>
        </div>
      </div>
    );
  }

  // Показуємо завантажувач поки відбувається редірект
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      backgroundColor: '#f5f5f5',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        fontSize: '48px',
        marginBottom: '20px'
      }}>
        📱
      </div>
      <h1 style={{
        fontSize: '24px',
        color: '#333',
        marginBottom: '10px'
      }}>
        Offer App
      </h1>
      <p style={{
        color: '#666',
        fontSize: '16px',
        textAlign: 'center'
      }}>
        Переспрямовуємо в магазин додатків...
      </p>
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #007AFF',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginTop: '20px'
      }}></div>
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default HomePage;